import { useEffect, useState } from 'react';

import { constants, types } from './definitions';
import {
  SupportApi,
  TicketingApi,
} from '@twiliointernal/e2-commons-shared-api';
import { getOscConfig } from '@twiliointernal/e2-commons-shared-definitions';
import { logger } from '@twiliointernal/e2-commons-shared-libs';
import { useExperiment } from '@twiliointernal/e2-commons-shared-hooks';
import { splitExperiments } from '../../definitions/constants';
import { useGetExperimentAccountSid } from '../../providers/experimentProvider';

const { priorityLevelFieldId } = getOscConfig();

function useGetPriorityLevelFields(): types.UseGetPriorityLevelFieldsReturn {
  const experimentAccountSid = useGetExperimentAccountSid();
  const { isOn: isSplitExperimentOn, isLoadingTreatment } = useExperiment({
    experimentName: splitExperiments.hcPlatMigrationTicketing,
    accountSid: experimentAccountSid,
  });
  const [status, setStatus] = useState<types.UseGetPriorityLevelFieldsReturn>({
    priorityLevels: [],
    loading: true,
  });

  useEffect(() => {
    if (!isLoadingTreatment) {
      (async (): Promise<void> => {
        try {
          // TODO: remove after validating the split experiment is working as expected
          logger.info(`${constants.LOG_PREFIX}::Split experiment`, {
            isSplitExperimentOn,
            experimentName: splitExperiments.hcPlatMigrationTicketing,
          });

          const {
            data: { custom_field_options: priorityLevels },
          } = isSplitExperimentOn
            ? await TicketingApi.getTicketField(priorityLevelFieldId)
            : await SupportApi.getTicketField(priorityLevelFieldId);

          setStatus({
            loading: false,
            priorityLevels,
          });
        } catch (err) {
          logger.error(`${constants.LOG_PREFIX}::${err}`);

          setStatus({
            priorityLevels: [],
            loading: false,
            error: err as Error,
          });
        }
      })();
    }
  }, [isLoadingTreatment]);

  return status;
}

export default useGetPriorityLevelFields;
